window.addEventListener("load",(()=>{document.querySelectorAll(".year").forEach((e=>{e.innerHTML=(new Date).getFullYear()}))}));
//# sourceMappingURL=main-wow.min.js.map
